import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomerInterface } from '@contracts/interfaces/customer.interface';
import { CustomerService } from 'src/app/services/customer.service';
import { TemplateService } from 'src/app/services/template.service';
import { SendSMSServiceDialog } from '../send-sms/send-sms.service.dialog';
import { InvoicesService } from 'src/app/services/invoices.service';
import { InvoiceInterface } from '@contracts/interfaces/invoice.interface';

export interface DialogData {
  customer: CustomerInterface;
  setName: string;
}

@Component({
  selector: 'app-customerdialog',
  templateUrl: 'customer.dialog.html',
  styleUrls: ['./customer.dialog.scss']
})
export class CustomerDialogComponent {

  tab = "customer";

  customer: CustomerInterface;
  mode: string = "create";
  reviewTemplate: string = "sms-review-request.template.html";
  reviewSending = false;
  reviewError: string | null = null;
  invoices: InvoiceInterface[] = [];
  invoicesLoading = false;
  invoicesError: string | null = null;
  reviewTemplates = [
    { id: 'sms-review-request.template.html', label: 'Standard review request' },
    { id: 'sms-review-request-aged.template.html', label: 'Aged review request' }
  ];
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public customerService: CustomerService,
    private templateService: TemplateService,
    private sendSMSServiceDialog: SendSMSServiceDialog,
    private invoicesService: InvoicesService,
    public dialogRef: MatDialogRef<CustomerDialogComponent>) {
     
      if (data.customer != null) {
        this.customer = data.customer;
        this.mode = "update";
        const legacyHasLeft = (this.customer as any).hasLeftGoogleReview;
        if (!this.customer.googleReviewStatus) {
          if (legacyHasLeft === true) {
            this.customer.googleReviewStatus = 'left';
          } else {
            this.customer.googleReviewStatus = 'not_requested';
          }
        }

        this.loadInvoices();
      } else {
        let name = data.setName;

        this.customer = {
          name: name,
          phone: "",
          phone2: "",
          address: "",
          email: "",
          remoteID: "",
          notes: "",
          googleReviewSMS: [],
          googleReviewStatus: 'not_requested'
        } as CustomerInterface;
        this.mode = "create";
      }
    }


  next() {

  }

  previous() {
    
  }

  save() {
    if (this.mode == "create") {
      this.customerService.createOne(this.customer).subscribe((response: any) => {
        this.customer = response.customer;
        this.mode = "update";
      })
    } else {
      this.customerService.updateOne(this.customer).subscribe(r => {})
    }
  }

  saveAndClose() {

    if (this.mode == "create") {
      this.customerService.createOne(this.customer).subscribe((response: any) => {
        this.dialogRef.close(response.customer);
      })
    } else {
      this.customerService.updateOne(this.customer).subscribe((response: any) => {
        this.dialogRef.close(response.customer);
      })
    }
  }

  reviewStatusLabel(status: CustomerInterface['googleReviewStatus'] | undefined): string {
    switch (status) {
      case 'requested':
        return 'Review request sent';
      case 'left':
        return 'Review left';
      case 'do_not_request':
        return 'Do not request';
      default:
        return 'No review request sent';
    }
  }

  loadInvoices() {
    if (!this.customer?._id) {
      this.invoices = [];
      return;
    }

    this.invoicesLoading = true;
    this.invoicesError = null;

    this.invoicesService.find({ "customer._id": this.customer._id }).subscribe({
      next: (invoices: InvoiceInterface[]) => {
        this.invoices = invoices || [];
        this.invoicesLoading = false;
      },
      error: () => {
        this.invoicesLoading = false;
        this.invoicesError = "Unable to load invoices for this customer.";
      }
    });
  }

  openInvoice(invoice: InvoiceInterface) {
    this.invoicesService.openInvoiceDialog(invoice, (updated: InvoiceInterface) => {
      if (updated) {
        const idx = this.invoices.findIndex(inv => inv.number === updated.number);
        if (idx >= 0) {
          this.invoices[idx] = updated;
        }
      }
    });
  }

  sendReviewSMS() {
    if (!this.customer?.phone) {
      this.reviewError = "Customer needs a phone number before sending SMS.";
      return;
    }

    this.reviewSending = true;
    this.reviewError = null;

    const vars = {
      customer: this.customer,
      toName: this.customer?.name,
      reviewLink: "https://g.page/r/CR-ekYinBCYvEAg/review"
    };

    this.templateService.renderFile(this.reviewTemplate, vars).subscribe({
      next: (template: any) => {
        this.sendSMSServiceDialog.open(this.customer, template.render, (job: any) => {
          this.reviewSending = false;
          if (job) {
            if (!this.customer.googleReviewSMS) {
              this.customer.googleReviewSMS = [];
            }
            this.customer.googleReviewSMS.push(new Date());
            if (this.customer.googleReviewStatus !== 'left') {
              this.customer.googleReviewStatus = 'requested';
            }
            this.customerService.updateOne(this.customer).subscribe();
          }
        });
      },
      error: () => {
        this.reviewSending = false;
        this.reviewError = "Failed to render SMS template.";
      }
    });
  }

  delete() {
    this.customerService.deleteOne(this.customer).subscribe(r=> {
      this.dialogRef.close(null);
    })
  }

  cancel() {
    this.dialogRef.close({
      action: "cancel"
    })
  }
}
